



























import { Vue, Component } from "vue-property-decorator";

import { namespace } from "vuex-class";

const auth = namespace("auth");
@Component({})
export default class Navigation extends Vue {
  @auth.Getter
  public authenticated!: boolean;

  @auth.Getter
  public fullName!: string

  public erros = {} as object  

  logout() {
    this.$store
      .dispatch("auth/logout")
      .then(() => {
        this.$router.currentRoute.name != 'Home' ? this.$router.push('/'): ''; 
      })
      .catch(error => {
        this.erros =  error.response.data 
      });
  }

  created() {
    console.log(` .Get authenticated  ${this.authenticated} `);

  }
}
